<div class="main-box" *transloco="let t; prefix: 'fuelShared'">
  <div class="top-title">
    <h2>{{ title }}</h2>
    <button (click)="closeModal()">
      <img src="assets/images-fuel/closeModalBtnIcon.svg" alt="icon-close" />
    </button>
  </div>

  <div class="main-table fuel-changes-modal-table table-modal">
    <table class="table">
      <thead>
        <tr>
          <th class="factor">{{ t('table.factor') }}</th>
          <th class="last-month">
            {{ modalFilterHeaders.previous }}
            <button class="filter-button" (click)="sortBy('previousValue')">
              <img src="assets/images-fuel/filterIconMainTable.svg" alt="filter-btn" />
            </button>
          </th>
          <th class="this-month">
            {{ modalFilterHeaders.current }}
            <button class="filter-button" (click)="sortBy('currentValue')">
              <img src="assets/images-fuel/filterIconMainTable.svg" alt="filter-btn" />
            </button>
          </th>
          <th class="change">
            {{ t('table.change') }}
            <button class="filter-button" (click)="sortBy('percentageChange')">
              <img src="assets/images-fuel/filterIconMainTable.svg" alt="filter-btn" />
            </button>
          </th>
        </tr>
      </thead>

      <tbody *ngIf="isLoading" class="spinner-container d-flex align-items-center justify-content-center spinner-border">
      </tbody>

      <tbody *ngIf="!isLoading">
        <tr *ngFor="let row of factors">
          <td class="factor"><p class="bold-text">{{ row.factorName }}</p></td>
          <td class="last-month"><p>{{ formatters[row.factorName](row.previousValue) }}</p></td>
          <td class="this-month"><p>{{ formatters[row.factorName](row.currentValue) }}</p></td>
          <td class="change"><p>{{ row.percentageChange + '%' }}</p></td>
        </tr>
      </tbody>
    </table>
  </div>
</div>